// Form helpers for the get-quote step: US phone masking + email validation.

/** The national 10 digits of a US phone (drops a leading country-code "1"). */
export function phoneDigits(input: string): string {
  // This field round-trips its own masked output ("+1 (512) …"), so the country code arrives here
  // as a literal digit. Strip the "+1" prefix BEFORE extracting digits — counting it made every
  // keystroke re-ingest it as an area-code "1" (typing 512… rendered "+1 (151) 2…" and worse).
  const trimmed = input.trimStart();
  const bare = trimmed.startsWith("+1") ? trimmed.slice(2) : trimmed;
  let d = bare.replace(/\D/g, "");
  // Pasted 11-digit forms without the "+" ("15125551234") still shed their country code.
  if (d.length === 11 && d.startsWith("1")) d = d.slice(1);
  return d.slice(0, 10);
}

/**
 * Masks input to the US format `+1 (000) 000-0000` as the user types. Accepts pasted values like
 * `5125551234`, `(512) 555-1234`, or `+15125551234`. Empty input keeps the `+1 ` affordance.
 */
export function formatUsPhone(input: string): string {
  const digits = phoneDigits(input);
  if (digits.length === 0) return "+1 ";
  const a = digits.slice(0, 3), b = digits.slice(3, 6), c = digits.slice(6, 10);
  if (digits.length <= 3) return `+1 (${a}`;
  if (digits.length <= 6) return `+1 (${a}) ${b}`;
  return `+1 (${a}) ${b}-${c}`;
}

/** A complete US phone has exactly 10 national digits. */
export function isPhoneComplete(input: string): boolean {
  return phoneDigits(input).length === 10;
}

/** Lightweight email shape check — local@domain.tld, no spaces. */
export function isValidEmail(email: string): boolean {
  return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email.trim());
}
